export default (function (value) {
  return value === null;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isNull.js
// module id = 1853
// module chunks = 0